export enum TimeInForceEnum {
  DAY = 'DAY',
  GTC = 'GTC',
  OPG = 'OPG',
  IOC = 'IOC',
  FOK = 'FOK',
  GTD = 'GTD',
  ATC = 'ATC',
  GFA = 'GFA'
}
